import { HousekeepingInoperationStatus } from '@ac/library-api';

export const HousekeepingInoperationStates = [
  HousekeepingInoperationStatus.OutOfOrder,
  HousekeepingInoperationStatus.OutOfService
];



// WEBPACK FOOTER //
// ./src/shared/consts/inoperationStates/housekeepingInoperationStates.ts